import { render, staticRenderFns } from "./PlanPartnersInfo.vue?vue&type=template&id=6716691a&scoped=true&"
import script from "./PlanPartnersInfo.vue?vue&type=script&lang=js&"
export * from "./PlanPartnersInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlanPartnersInfo.vue?vue&type=style&index=0&id=6716691a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716691a",
  null
  
)

export default component.exports